import React, { useEffect, useState } from 'react'
import styles from './AddNewDeal.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import MultiCheckbox from 'components/UI/Checkbox/MultiCheckbox'
import SearchInput from 'components/ContentBox/Global/SearchInput/SearchInput'
import useLocalization from 'hooks/useLocalization'
import InputFlagPhone from 'components/ContentBox/Global/InputPhone/InputFlagPhone/InputFlagPhone'
import { superAxiosRequest } from 'axiosApi'
import { observer } from 'mobx-react'
import FormDateSelector from '../../../../../../UI/AsideModal/Form/FormDateSelector'
import { timeConverter2 } from '../../../../../Online-schedule/components/functions'

const AddNewDeal = ({ isEdit, dealId, funnelId }) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
    setValid,
  } = asideModalStore
  const [client, setClient] = useState(null)
  const [fields, setFields] = useState([])
  const [fieldsValue, setFieldsValue] = useState([])
  const [fetchRequireFields, setFetchRequireFields] = useState({
    manager: [],
    dealNameText: null,
  })
  const [isNewClient, setIsNewClient] = useState(isEdit ? false : null)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      budget: 'Budget',
      city: 'City',
      select_city: 'Select city',
      deal_name: 'Deal name',
      responsible: 'Responsible',
      select_responsible: 'Select responsible',
      branch: 'Branch',
      select_branch: 'Select branch',
      select_program: 'Select program',
      program: 'Program',
      level: 'Level',
      select_level: 'Select level',
      client: 'Client',
      name: 'Name',
      client_type: 'Select client type',
      new_client: 'New client',
      existing_client: 'Existing client',
    },
  })

  const updateValidation = () => {
    const customValidations = {}

    fields.forEach((field) => {
      if (field.is_required) {
        const value = fieldsValue.find(
          (v) => v.additional_funnel_field === field.id,
        )?.value

        let isValid = false
        if (field.type === 'boolean') {
          isValid = value === true || value === false
        } else if (field.type === 'calendar') {
          isValid = value && value.trim() !== ''
        } else {
          isValid = value && value.toString().trim() !== ''
        }

        if (!isValid) {
          customValidations[`custom_field_${field.id}`] = 'required'
        }
      }
    })

    const baseValidations = modalValue.hasOwnProperty('client_text_phone')
      ? {
          client_text_name: 'required',
          client_text_phone: 'required',
        }
      : {
          client: 'required',
        }

    setValid({
      ...baseValidations,
      ...customValidations,
    })
  }
  useEffect(() => {
    updateValidation()
  }, [fields, fieldsValue, modalValue.client_text_phone, modalValue.client])

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      try {
        const [managerResponse, dealNameResponse] = await Promise.all([
          superAxiosRequest({
            link: 'integration/employees',
            method: 'get',
            crm: true,
            params: { limit: 9999 },
          }),
          superAxiosRequest({
            link: 'integration/deal_name_next',
            method: 'get',
            crm: true,
          }),
        ])

        if (isMounted) {
          const responsibleOptions = managerResponse.data.result.map(
            (responsible) => ({
              id: responsible.id,
              name: responsible.full_name,
            }),
          )

          setFetchRequireFields({
            manager: responsibleOptions,
            dealNameText: dealNameResponse.data.deal_name,
          })
        }
      } catch (error) {
        console.error(error)
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [])

  const fetchFieldsValue = () => {
    superAxiosRequest({
      link: `integration/additional_funnel_deal_field_values`,
      method: 'get',
      crm: true,
      params: {
        funnel_id: funnelId,
        deal_id: dealId,
      },
    })
      .then(({ data }) => {
        setFieldsValue(data)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const fetchFields = () => {
    superAxiosRequest({
      link: `integration/additional_funnel_deal_fields`,
      method: 'get',
      crm: true,
      params: {
        funnel_id: funnelId,
      },
    })
      .then(({ data }) => {
        setFields(data)
      })
      .catch(() => {})
      .finally(() => {})
  }

  useEffect(() => {
    if (isEdit) {
      fetchFields()
      fetchFieldsValue()
    }
  }, [isEdit])

  const handleFieldChange = (id, value) => {
    const existingFieldValue = fieldsValue.find(
      (v) => v.additional_funnel_field === id,
    )

    const processedValue = typeof value === 'boolean' ? value.toString() : value

    if (existingFieldValue) {
      setFieldsValue((prevFieldsValue) =>
        prevFieldsValue.map((v) =>
          v.additional_funnel_field === id
            ? { ...v, value: processedValue }
            : v,
        ),
      )
    } else {
      setFieldsValue((prevFieldsValue) => [
        ...prevFieldsValue,
        { id: null, additional_funnel_field: id, value: processedValue },
      ])
    }
  }

  const addOrUpdateFieldValue = (id, value) => {
    const existingValue = fieldsValue.find(
      (v) => v.additional_funnel_field === id,
    )

    if (existingValue && existingValue.id) {
      superAxiosRequest(
        {
          link: `integration/additional_funnel_deal_field_values/${existingValue.id}`,
          method: 'put',
          crm: true,
        },
        {
          deal: dealId,
          value: value,
          additional_funnel_field: id,
        },
      )
        .then(({ data }) => {
          const updatedFieldsValue = fieldsValue.map((v) =>
            v.id === existingValue.id ? { ...v, value } : v,
          )
          setFieldsValue(updatedFieldsValue)
        })
        .catch((err) => {
          console.error(err)
        })
    } else {
      superAxiosRequest(
        {
          link: `integration/additional_funnel_deal_field_values`,
          method: 'post',
          crm: true,
        },
        {
          deal: dealId,
          value: value,
          additional_funnel_field: id,
        },
      )
        .then(({ data }) => {
          setFieldsValue((prevFieldsValue) => [
            ...prevFieldsValue.filter((v) => v.additional_funnel_field !== id),
            data,
          ])
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }

  const mappedDealsFields = fields.map((field) => {
    const fieldValue =
      fieldsValue.find((value) => value.additional_funnel_field === field.id)
        ?.value || ''

    const hasError = check(`custom_field_${field.id}`)

    return (
      <FormField
        key={field.id}
        onClick={() => document.getElementById(`input-${field.id}`)?.focus()}
      >
        {field.type === 'string' ? (
          <>
            <FormLabel isRequired={field.is_required}>{field?.name}:</FormLabel>
            <FormInput isError={hasError}>
              <input
                id={`input-${field.id}`}
                type='text'
                value={fieldValue}
                onChange={(e) => {
                  const updatedFieldValue = e.target.value
                  handleFieldChange(field.id, updatedFieldValue)
                }}
                onBlur={(e) => {
                  const updatedFieldValue = e.target.value
                  addOrUpdateFieldValue(field.id, updatedFieldValue)
                }}
              />
            </FormInput>
          </>
        ) : field.type === 'calendar' ? (
          <>
            <FormLabel isRequired={field.is_required}>{field?.name}:</FormLabel>
            <FormDateSelector
              placeholder={translate.date}
              onChange={(date) => {
                const updatedFieldValue = date ? timeConverter2(date) : ''
                handleFieldChange(field.id, updatedFieldValue)
                addOrUpdateFieldValue(field.id, updatedFieldValue)
              }}
              value={fieldValue || ''}
              error={hasError}
            />
          </>
        ) : (
          <ul
            className={`${styles.multiCheckbox} ${hasError ? styles.multiCheckboxError : ''}`}
          >
            <FormLabel isRequired={field.is_required}>{field?.name}:</FormLabel>
            <MultiCheckbox
              checked={fieldValue === 'true' || fieldValue === true}
              onChange={() => {
                const updatedValue = !(
                  fieldValue === 'true' || fieldValue === true
                )
                handleFieldChange(field.id, updatedValue)
                addOrUpdateFieldValue(field.id, updatedValue)
              }}
            />
          </ul>
        )}
      </FormField>
    )
  })

  const getStudentList = (value) => {
    const client = Array.isArray(value) ? value[0] : value
    setClient(client?.name)
    changeValues(client?.id, 'client')
    changeValues(client?.name, 'client_name')
  }

  const renderClientTypeSelection = () => (
    <FormField>
      <FormLabel>{translate.client_type}:</FormLabel>
      <div className={styles.btns}>
        <button onClick={() => setIsNewClient(true)}>
          {translate.new_client}
        </button>
        <button onClick={() => setIsNewClient(false)}>
          {translate.existing_client}
        </button>
      </div>
    </FormField>
  )

  const renderClientFields = () => {
    if (!isEdit && isNewClient === null) {
      return renderClientTypeSelection()
    }

    if (isNewClient) {
      return (
        <>
          <FormField>
            <FormLabel isRequired>{'Имя клиента'}:</FormLabel>
            <FormInput isError={check('client_text_name')}>
              <input
                placeholder={'Имя клиента'}
                type='text'
                value={modalValue.client_text_name || ''}
                onChange={(e) =>
                  changeValues(e.target.value, 'client_text_name')
                }
                maxLength={30}
              />
            </FormInput>
          </FormField>
          <FormField>
            <FormLabel isRequired>Телефон клиента:</FormLabel>
            <InputFlagPhone
              error={check('client_text_phone')}
              value={modalValue.client_text_phone || ''}
              onChange={(val) => changeValues(val, 'client_text_phone')}
            />
          </FormField>
        </>
      )
    }

    return (
      <FormField>
        <FormLabel>{translate?.client}:</FormLabel>
        <SearchInput
          link='integration/clients'
          placeholder={translate?.name}
          new_key='name'
          backFunction={getStudentList}
          crm={true}
          initialValue={client || modalValue.client_name}
          error={check('client')}
        />
      </FormField>
    )
  }

  return (
    <div className={styles.groupForm}>
      {!isEdit && isNewClient === null ? (
        renderClientTypeSelection()
      ) : (
        <>
          <FormField>
            <FormLabel>{translate?.deal_name}:</FormLabel>
            <FormInput isError={check('deal_name')}>
              <input
                placeholder={translate?.deal_name}
                type='text'
                value={
                  modalValue.deal_name || fetchRequireFields.dealNameText || ''
                }
                onChange={(e) => changeValues(e.target.value, 'deal_name')}
                maxLength={100}
              />
            </FormInput>
          </FormField>
          <FormField>
            <FormLabel>{translate?.responsible}:</FormLabel>
            <SelectCustom
              placeholder={translate?.select_responsible}
              options={fetchRequireFields.manager}
              sortKey='name'
              valueID={modalValue.manager}
              onChange={(manager) => changeValues(manager.id, 'manager')}
              isSearchable
              error={check('manager')}
            />
          </FormField>
          {renderClientFields()}
          <FormField>
            <FormLabel>{translate?.budget}, ₸:</FormLabel>
            <FormInput isError={check('budget')}>
              <input
                placeholder={translate?.budget}
                type='number'
                value={modalValue.budget || ''}
                onChange={(e) => changeValues(e.target.value, 'budget')}
              />
            </FormInput>
          </FormField>
          <FormField>
            <FormLabel>{translate?.city}:</FormLabel>
            <SelectCustom
              placeholder={translate?.select_city}
              apiLinkCRM={'integration/cities'}
              apiConfParams={{ limit: 99 }}
              sortKey='name'
              valueID={modalValue.city}
              onChange={(city) => changeValues(city.id, 'city')}
              isSearchable
              error={check('city')}
            />
          </FormField>
          <FormField>
            <FormLabel>{translate?.branch}:</FormLabel>
            <SelectCustom
              placeholder={translate?.select_branch}
              apiLinkCRM={'integration/branches'}
              sortKey='name'
              valueID={modalValue.branch}
              onChange={(branch) => changeValues(branch.id, 'branch')}
              isSearchable
              error={check('branch')}
            />
          </FormField>
          <FormField>
            <FormLabel>{translate?.program}:</FormLabel>
            <SelectCustom
              placeholder={translate?.select_program}
              apiLinkCRM={'integration/programs'}
              sortKey='name'
              valueID={modalValue.program}
              onChange={(program) => changeValues(program.id, 'program')}
              isSearchable
              error={check('program')}
            />
          </FormField>
          <FormField>
            <FormLabel>{translate?.level}:</FormLabel>
            <SelectCustom
              placeholder={translate?.select_level}
              apiLinkCRM={'integration/teaching_levels'}
              sortKey='name'
              valueID={modalValue.level}
              onChange={(level) => changeValues(level.id, 'level')}
              isSearchable
              error={check('level')}
            />
          </FormField>
          {isEdit && isNewClient === false && (
            <>
              <FormField>
                <FormLabel>{'Reason for refusal'}:</FormLabel>
                <SelectCustom
                  placeholder={translate?.select_level}
                  apiLinkCRM={
                    'settings/project_settings/deal_reject_reason_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.reject_reason}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(level) =>
                    changeValues(level.name, 'reject_reason')
                  }
                  isSearchable
                  error={check('reject_reason')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Вид обучения'}:</FormLabel>
                <SelectCustom
                  placeholder={'Вид обучения'}
                  apiLinkCRM={
                    'settings/project_settings/deal_learning_type_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.learning_type}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(level) =>
                    changeValues(level.name, 'learning_type')
                  }
                  isSearchable
                  error={check('learning_type')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Тип обучения'}:</FormLabel>
                <SelectCustom
                  placeholder={'Тип обучения'}
                  apiLinkCRM={
                    'settings/project_settings/deal_education_type_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.education_type}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(level) =>
                    changeValues(level.name, 'education_type')
                  }
                  isSearchable
                  error={check('education_type')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Цель обучения'}:</FormLabel>
                <SelectCustom
                  placeholder={'Цель обучения'}
                  apiLinkCRM={
                    'settings/project_settings/deal_learning_goal_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.learning_goal}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(level) =>
                    changeValues(level.name, 'learning_goal')
                  }
                  isSearchable
                  error={check('learning_goal')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Дни обучения'}:</FormLabel>
                <SelectCustom
                  placeholder={'Дни обучения'}
                  apiLinkCRM={
                    'settings/project_settings/deal_learning_days_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.learning_days}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(level) =>
                    changeValues(level.name, 'learning_days')
                  }
                  isSearchable
                  error={check('learning_days')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Источник'}:</FormLabel>
                <SelectCustom
                  placeholder={'Источник'}
                  apiLinkCRM={'settings/project_settings/deal_source_choices'}
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.source}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(level) => changeValues(level.name, 'source')}
                  isSearchable
                  error={check('source')}
                />
              </FormField>

              <FormField>
                <FormLabel>Curator:</FormLabel>
                <SelectCustom
                  placeholder={'Curator'}
                  options={fetchRequireFields.manager}
                  sortKey='name'
                  valueID={modalValue.curator}
                  onChange={(manager) => changeValues(manager.id, 'curator')}
                  isSearchable
                  error={check('curator')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Способ оплаты'}:</FormLabel>
                <SelectCustom
                  placeholder={'Способ оплаты'}
                  apiLinkCRM={
                    'settings/project_settings/deal_payment_method_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.payment_method}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(item) => changeValues(item.name, 'payment_method')}
                  isSearchable
                  error={check('payment_method')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Смена обучения'}:</FormLabel>
                <SelectCustom
                  placeholder={'Смена обучения'}
                  apiLinkCRM={
                    'settings/project_settings/deal_study_shift_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.study_shift}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(item) => changeValues(item.name, 'study_shift')}
                  isSearchable
                  error={check('study_shift')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Класс ученика'}:</FormLabel>
                <SelectCustom
                  placeholder={'Класс ученика'}
                  apiLinkCRM={
                    'settings/project_settings/deal_students_grade_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.students_grade}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(item) => changeValues(item.name, 'students_grade')}
                  isSearchable
                  error={check('students_grade')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Школа ученика'}:</FormLabel>
                <SelectCustom
                  placeholder={'Школа ученика'}
                  apiLinkCRM={
                    'settings/project_settings/deal_students_school_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.students_school}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(item) =>
                    changeValues(item.name, 'students_school')
                  }
                  isSearchable
                  error={check('students_school')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Результат уровня'}:</FormLabel>
                <SelectCustom
                  placeholder={'Результат уровня'}
                  apiLinkCRM={
                    'settings/project_settings/deal_level_result_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.level_result}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(item) => changeValues(item.name, 'level_result')}
                  isSearchable
                  error={check('level_result')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Причина ухода'}:</FormLabel>
                <SelectCustom
                  placeholder={'Причина ухода'}
                  apiLinkCRM={
                    'settings/project_settings/deal_reason_for_leaving_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.reason_for_leaving}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(item) =>
                    changeValues(item.name, 'reason_for_leaving')
                  }
                  isSearchable
                  error={check('reason_for_leaving')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Причина повторного обучения'}:</FormLabel>
                <SelectCustom
                  placeholder={'Причина повторного обучения'}
                  apiLinkCRM={
                    'settings/project_settings/deal_reason_for_repeating_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.reason_for_repeating}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(item) =>
                    changeValues(item.name, 'reason_for_repeating')
                  }
                  isSearchable
                  error={check('reason_for_repeating')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'Возрастная категория'}:</FormLabel>
                <SelectCustom
                  placeholder={'Возрастная категория'}
                  apiLinkCRM={
                    'settings/project_settings/deal_age_category_choices'
                  }
                  apiGetResult={(result) => result.value.choices}
                  valueID={modalValue.age_category}
                  optionLabelKey='name'
                  optionValueKey='name'
                  onChange={(item) => changeValues(item.name, 'age_category')}
                  isSearchable
                  error={check('age_category')}
                />
              </FormField>

              <FormField>
                <FormLabel>{'UTM Source'}:</FormLabel>
                <FormInput isError={check('utm_source')}>
                  <input
                    placeholder={'UTM Source'}
                    type='text'
                    value={modalValue.utm_source || ''}
                    onChange={(e) => changeValues(e.target.value, 'utm_source')}
                    maxLength={50}
                  />
                </FormInput>
              </FormField>
              <FormField>
                <FormLabel>{'UTM Medium'}:</FormLabel>
                <FormInput isError={check('utm_medium')}>
                  <input
                    placeholder={'UTM Medium'}
                    type='text'
                    value={modalValue.utm_medium || ''}
                    onChange={(e) => changeValues(e.target.value, 'utm_medium')}
                    maxLength={50}
                  />
                </FormInput>
              </FormField>
              <FormField>
                <FormLabel>{'UTM Campaign'}:</FormLabel>
                <FormInput isError={check('utm_campaign')}>
                  <input
                    placeholder={'UTM Campaign'}
                    type='text'
                    value={modalValue.utm_campaign || ''}
                    onChange={(e) =>
                      changeValues(e.target.value, 'utm_campaign')
                    }
                    maxLength={50}
                  />
                </FormInput>
              </FormField>
              <FormField>
                <FormLabel>{'UTM Content'}:</FormLabel>
                <FormInput isError={check('utm_content')}>
                  <input
                    placeholder={'UTM Content'}
                    type='text'
                    value={modalValue.utm_content || ''}
                    onChange={(e) =>
                      changeValues(e.target.value, 'utm_content')
                    }
                    maxLength={50}
                  />
                </FormInput>
              </FormField>
              <FormField>
                <FormLabel>{'UTM Term'}:</FormLabel>
                <FormInput isError={check('utm_term')}>
                  <input
                    placeholder={'UTM Term'}
                    type='text'
                    value={modalValue.utm_term || ''}
                    onChange={(e) => changeValues(e.target.value, 'utm_term')}
                    maxLength={50}
                  />
                </FormInput>
              </FormField>
            </>
          )}

          {!!mappedDealsFields.length && mappedDealsFields}
        </>
      )}
    </div>
  )
}

export default observer(AddNewDeal)
